export function message(alert) {
    window.addEventListener('unhandledrejection', (e) => {
        if (!e?.reason) return
        if (
            e.reason.name === 'AbortError' ||
            Object.hasOwn(e.reason, '__alerted') ||
            Object.hasOwn(e.reason, '__alert_ignore')
        ) {
            e.preventDefault()
        }
    })

    return (request, next) => {
        if (request.alert === false) {
            return next(request)
        }

        const message_ = request.alertMessage ?? alert ?? ((error) => console.warn?.(error.message))
        const messageFunction = typeof message_ === 'function' ? message_ : () => message_

        return next(request).catch((error) => {
            if (error instanceof Error) {
                if (error.name === 'AbortError') {
                    error.__alert_ignore = true
                    console.debug('[fetch] request abort', error.message)
                } else {
                    error.__alerted = true
                    messageFunction(error, request)
                }
            }

            throw error
        })
    }
}
